// src/components/InsightsWidget.jsx

import React from "react";

export default function InsightsWidget({ title = "Insights", insights = [] }) {
  const list = Array.isArray(insights) ? insights : [];

  return (
    <div className="insw-card">
      <div className="insw-title">{title}</div>

      {list.length ? (
        <ul className="insw-list">
          {list.map((t, i) => (
            <li key={i} className="insw-item">
              {String(t)}
            </li>
          ))}
        </ul>
      ) : (
        <div className="insw-empty">Sem insights disponíveis.</div>
      )}
    </div>
  );
}
